import { BcSalesOrder } from "src/api-service";
import { AppError } from "../../app-store-error.types";

// **************************************************************************
// SALES ORDER STATE
// **************************************************************************

export interface SalesOrderState {
    salesOrder: BcSalesOrder | null;
    salesOrders: BcSalesOrder[];
    // List UI state
    loaded: boolean;
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    sortProperty: string | null;
    sortAscending: boolean;
    // Filters
    orderNo: string;
    externalDocumentNo: string;
    salesChannelCode: string;
    customerContactName: string;
    customerNo: string;
    salespersonCode: string;
    // Loading
    loadingList: boolean;
    loadingDetail: boolean;
    // Error
    error: AppError | null;
}

export const initialSalesOrderState: SalesOrderState = {
    salesOrder: null,
    salesOrders: [],
    // List UI state
    loaded: false,
    pageNumber: 1,
    pageSize: 20,
    totalCount: 0,
    sortProperty: null,
    sortAscending: true,
    // Filters
    orderNo: "",
    externalDocumentNo: "",
    salesChannelCode: "",
    customerContactName: "",
    customerNo: "",
    salespersonCode: "",
    // Loading
    loadingList: false,
    loadingDetail: false,
    // Error
    error: null,
};
